export default {
  "cod100": "Por favor insira o código da entidadee.",
  "cod101": "O código da entidade não foi encontrado na base de dados.",
  "cod102": "A combinação código da entidade e fonte de informação já existe no arquivo.",
  "cod199": "Ocorreu um erro al carregar o arquivo, não foi possível criar uma nova entidade na plataforma.",
  "cod200": "Por favor insira o código da fonte de informação.",
  "cod201": "O código da fonte de informação já existe na base de dados.",
  "cod300": "Por favor insira a fonte de informação.",
  "cod301": "A fonte de informação não foi encontrada na base de dados.",
  "cod302": "A fonte de informação não foi encontrada na base de dados.",
  "cod305": "Não foi possível atualizar o usuário. A senha e a confirmação não coincidem.",
  "cod310": "Não foi possível atualizar o usuário. A senha não atende ao formato exigido.",
  "cod311": "Não foi possível atualizar o usuário. A senha atual não coincide com a do usuário conectado.",
  "cod400": "Por favor insira o código da entidade.",
  "cod401": "O código não foi encontrado na base de dados.",
  "cod402": "O código já existe no arquivo.",
  "cod403": "O código já existe na base de dados.",
  "cod404": "O código já existe na base de dados, porém, desabilitado.",
  "cod500": "Por favor insira o nome da entidade.",
  "cod600": "Por favor selecione pelo menos um item de uma categoria.",
  "cod601": "O item da categoria não foi encontrado na base de dados.",
  "cod602": "O ou os items categoria não pode ser atribuído já que não pertencem ao do usuário identificado no Sistema. (na criação e edição de um usuário)",
  "cod603": "Não é possível realizar esta atribuição de categorias. Estes ítems de categorias nãoo pertencem ao usuário identificado no sistema.",
  "cod700": "Por favor insira o polígono da geozona.",
  "cod701": "Erro na criação do polígono.",
  "cod800": "É requerido o ID da entidade.",
  "cod801": "O ID da entidade não foi encontrado na base de dados.",
  "cod802": "A combinação ID da entidade e fonte de informação já existe no arquivo.",
  "cod803": "A combinação ID da entidade e fonte de informação já existe na base de dados.",
  "cod900": "É requerido o ID da entidade desconhecida.",
  "cod901": "O ID da entidade desconhecida não foi encontrado na base de dados.",
  "cod994": "Por segurança você não pode ativar a si mesmo na plataforma.",
  "cod995": "Por segurança você não pode desativar a si mesmo da plataforma.",
  "cod999": "Erro no arquivo",
  "cod1000": "É requerido o ID",
  "cod1001": "O ID não foi encontrado na base de dados.",
  "cod1002": "O ID já existe no arquivo.",
  "cod1003": "O ID já existe na base de dados",
  "cod1004": "O ID já existe na base de dados, porém, desabilitado.",
  "cod1100": "Por favor insira a data de início.",
  "cod1200": "Por favor insira o e-mail",
  "cod1201": "O e-mail (username) não foi encontrado.",
  "cod1202": "O e-mail (username) já existe na lista de usuários que deseja guardar ou atualizar.",
  "cod1203": "O e-mail (username) já existe na base de dados.",
  "cod1204": "O e-mail (username) já existe na base de dados,porém, desabilitado.",
  "cod1205": "O e-mail ingressado não tem um formato válido.",
  "cod1300": "A senha é requerida.",
  "cod1301": "A repetição de senha é requerida.",
  "cod1302": "É requerido o ingresso de csenhas.",
  "cod1303": "As senhas não coincidem.",
  "cod1400": "Por favor insira um nome.",
  "cod1500": "Por favor insira pelo menos uma permissão.",
  "cod1501": "Permissão não encontrada no sistema.",
  "cod1502": "Permissão não encontrada no sistema.",
  "cod1600": "Por favor indique se o usuário é administrador.",
  "cod6500": "Não foi possível ler o arquivo, erro inesperado.",
  "cod6501": "Não foi possívelcarregar ou ingressar os dados do arquivo. (no atributo params da resposta no formato JSON tem os detalhes).",
  "cod6502": "Não foi possível ler o arquivo, cabeçalho incompatível.",
  "cod6503": "Por favor carregue o arquivo.",
  "cod6504": "Por favor insira dados requeridos no arquivo.",
  "cod6505": "Não existe a folha com os dados no arquivo",
  "cod9000": "Usuário não tem estas permissões habilitadas.",
  "cod9100": "Por segurança você não pode editar a si mesmo.",
  "cod10001": "Campo requerido Veículo.",
  "cod10002": "Campo requerido Condutor.",
  "cod10003": "Campo requerido Gerência.",
  "cod10004": "Campo requerido Carga.",
  "cod10005": "Campo requerido Direcção.",
  "cod10006": "Campo requerido Data e Hora.",
  "cod10007": "Campo requerido e-mail.",
  "cod10008": "Campo requerido Número Permissão MOP.",
  "cod10009": "Campo requerido arquivo Permissão MOP.",
  "cod10010": "Campo requerido Escolta.",
  "cod10011": "Campo requerido Tipo de Veículo.",
  "cod10012": "Formato de e-mail não válido.",
  "cod10013": "A Data e Hora não pode ser anterior a HOJE às",
  "cod10014": "A Data e Hora não pode ser superior 24 horas desde a hora atual.",
  "cod10015": "Campo Carga não pode ser maior a 128 caracteres.",
  "cod10016": "Campo Número Permissão MOP não pode ser maior a 64 caracteres.",
  "cod10017": "Campo Comentários não pode ser maior a 1024 caracteres.",
  "cod10018": "Campo e-mail não pode ser maior a 128 caracteres.",
  "codTag100": "O item já existe.",
  "codItem100": "O item já existe.",
  "codItem104": "O item já existe.",
  "codItem304": "O item já existe.",
  "codItem303": "O item já existe.",
  "codList100": "A lista já existe.",
  "codList104": "A lista já existe.",
  "codGroup500": "Por favor insira o nome do grupo.",
  "codGroup501": "Nome de grupo inválido (não é suportado o caracter ').",
  "codGroup1001": "Grupo não encontrado na base de dados.",
  "codGroup1900": "Por favor ingresse a lista de e-mails.",
  "codGroup1901": "Lista de e-mails inválida (cada e-mail deve ser separado por ,).",
  "codGroup503": "O nome do grupo já existe.",
  "codGroup504": "O nome do grupo já existe, porém, em uma entidade desativada.",
  "codGroup12000": "É necessário indicar se é ou não um turno dinâmico.",
  "codGroup13000": "É necessária a quantidade de dias.",
  "codGroup13001": "A quantidade de dias está fora da faixa, deve ser maior ou igual a 1.",
  "codGroup14000": "É necessário o planejamento horário.",
  "codGroup14001": "O planejamento horário não tem um formato válido, foi indicado que é tipo \"trabalho\" porém não foi indicado o horário.",
  "codGroup15000": "É necessária a data de início de turno.",
  "codGroup16000": "É necessário o tempo máximo para enviar o reporte.",
  "codGroup16001": "O tempo máximo para enviar o reporte está fora da faixa, deve ser maior ou igual a 1.",
  "codGroup17000": "É necessário o tempo máximo para realizar a avaliação despois do estabelecido.",
  "codGroup17001": "O tempo máximo para realizar a avaliação depois do estabelecido está fora da faixa, deve ser maior ou igual a 1.",
  "codGroup18000": "É necessário o tempo máximo para realizar a avaliação antes do estabelecido.",
  "codGroup18001": "O tempo máximo para realizar a avaliação antes do estabelecido está fora da faixa, deve ser maior ou igual a 1.",
  "codGroup14002": "O horário não tem um formato válido, deve haver pelo menos um dia do tipo \"trabalho\".",
  "codGroup18002": "O tempo máximo para realizar a avaliação antes da data estabelecida não pode ser inferior ao tempo máximo para envio do relatório.",
  "cod18102": "Não há grupo de turnos.",
  "cod11001": "Formato de Data inválido em algúm campo. Formato válido dd/mm/aaaa.",
  "cod1503": "A função para gerenciar os desvios não pode ser atribuída, pois o usuário não tem a função para visualizar os desvios atribuídos.",
  "codTask18200": "Você deve preencher este campo para fechar o desvio.",
  "cod605": "Não é possível realizar esta ação porque você não tem permissões suficientes para editar este tipo de usuário, para realizar esta tarefa você precisa de um usuário com permissões superiores",
  "cod606": "Não é possível realizar esta ação porque você não tem permissões suficientes para editar este tipo de usuário, para realizar esta tarefa você precisa de um usuário com permissões superiores",
  "cod1504": "Não é possível realizar esta ação porque você não tem permissões suficientes para editar este tipo de usuário, para realizar esta tarefa você precisa de um usuário com permissões superiores",
  "cod604": "Por favor insira pelo menos um item para cada uma das seguintes categorias",
  "apiErrorForm": "Ocorreu um erro, tente novamente",
  "apiError": "Ocorreu um erro, tente novamente",
  "apiError500": "Ocorreu um erro, tente novamente",
  "noData": "Ocorreu um erro, tente novamente",
  "noSetting": "Sem configuração",
  "cod607": "Não é possível atribuir mais de um item por categoria",
  "noAuthorization": "Sem Autorização",
  "cod5200": "Você enviou um formato de arquivo não permitido. Utilize um destes: {list-extensions}",
  "noRootAccess": "Não é possível realizar esta ação porque você não possui permissões suficientes para baixar o arquivo.",
  "invalidFileFormat": "O formato do arquivo não é válido; deve ser um arquivo Excel.",
  "serviceUnavailable": "Serviço indisponível. Por favor, tente novamente mais tarde.",
  "noValidAssignations": "O arquivo não continha nenhuma atribuição válida. Processo cancelado."
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/error.js